import Loader from '_atoms/Loader/Loader';
import { FC, ReactNode } from 'react';
import './Button.scss';

export type ButtonType = 'primary' | 'primary-soft' | 'secondary' | 'tertiary';

type PropsShape = {
    children: ReactNode;
    onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
    isDisabled?: boolean;
    isLoading?: boolean;

    /**
     * primary: filled with Whispering Red
     * primary-soft: filled with Dusty Pink
     * secondary: not filled, Whispering Red and text.
     * tertiary: no border. black text.
     */
    type?: ButtonType;
    size?: 'large' | 'medium' | 'small';

    classes?: string;
    id?: string;
    testId?: string;
};

const Button: FC<PropsShape> = ({
    id = '',
    classes = '',
    type = 'primary',
    size = 'large',
    isDisabled = false,
    isLoading = false,
    onClick,
    children,
}) => {
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        if (onClick) {
            event.preventDefault();
            onClick(event);
        }
    };

    let theClasses = `kan-button ${size}-btn`;
    if (classes.length) {
        theClasses += ' ' + classes;
    }

    if (isLoading) {
        theClasses += ' loading-btn';
    }

    switch (type) {
        case 'secondary':
            theClasses += ' secondary-btn';
            break;
        case 'primary-soft':
            theClasses += ' primary-soft-btn';
            break;
        case 'tertiary':
            theClasses += ' tertiary-btn';
            break;
    }

    return (
        <button
            id={id ?? ''}
            className={theClasses}
            onClick={handleClick}
            type="submit"
            disabled={isDisabled || isLoading}
        >
            {!isLoading ? (
                <div className="button-content">{children}</div>
            ) : (
                <Loader
                    isFullScreen={false}
                    size={size === 'large' ? 'medium' : 'small'}
                />
            )}
        </button>
    );
};

export default Button;
